import React from "react";
import { Link } from "react-router-dom";

const NotFound: React.FC = () => {
  return (
    <div className="min-h-screen flex items-center justify-center bg-secondary-50">
      <div className="text-center p-8 bg-white rounded shadow">
        <h1 className="text-4xl font-bold mb-4">404</h1>
        <p className="text-lg text-gray-600 mb-6">Page not found</p>
        <Link to="/" className="btn-primary">Go to Home</Link>
      </div>
    </div>
  );
};

export default NotFound;
